import IconApp from "assets/icons/logo.png";
import { Helmet } from "react-helmet";
type Props = {
  title: string | undefined;
};

function HelmetCustom(props: Props) {
  const { title = "" } = props;
  return (
    <Helmet>
      <title>{title + " Ed3333 Live"}</title>
      <link rel="icon" type="image/png" href={IconApp} />
    </Helmet>
  );
}

export default HelmetCustom;
